import { A5tableType } from '@/types'

// 初始化状态
const initState = {
  // 列表数据
  tableInfo: {
    list: [] as A5tableType[]
  }
}

// 定义 action 类型
type Props = {
  type: 'A5/getList'
  payload: { list: A5tableType[] }
}

// reducer
export default function Reducer(state = initState, action: Props) {
  switch (action.type) {
    // 获取列表数据
    case 'A5/getList':
      return { ...state, tableInfo: action.payload }

    default:
      return state
  }
}
